export const getOrderGroups = ({ items, orders }) =>
  items.reduce((acc, item) => {
    const { order_number: orderNumber } = item;
    if (!acc[orderNumber]) {
      acc[orderNumber] = {
        items: [],
        order: orders.find((order) => order.order_info.order_number === orderNumber),
      };
    }
    acc[orderNumber].items.push(item);
    return acc;
  }, {});
